/*
Then you can import your constants wherever you need them:
import Constants from '../Folder/Constants.js'

and use like such:
const x = Constants.SITE_NAME
*/

// these are not really constants as they can be modified anywhere
// should use static in a class for real constants

import React, { Fragment } from 'react';
import packageJson from '../package.json';

// images
import delphe_logo_banner from './resources/images/Delphe4.png'  // more "full" version
import delphe_logo from './resources/images/Delphe2.png'  // more subtle version
import delphe_logo_D from "./resources/images/Delphe1.png";
import bsv_logo from './resources/images/bsvlogo.png'



// should have no slash at the end
export const TOKKENR_NODE_HOST_URL = "https://node1.tokkenr.com/api/v1"
// export const TOKKENR_NODE_HOST_URL = "https://node2.tokkenr.com/api/v1"

const colorChocolate = "#d2691e"
const colorDarkRed = "rgb(170, 0, 0)"


const appConfigs = {
    "tokkenR": {
        name: "TokkenR",
        url: "https://tokkenr.com",
        url_display: "TokkenR.com",
        file_format: ".tokkenr",
        theme: {
            // note: #ffc107 (yellow) buttons also look very good on a dark-blue background
            // #00E8D1
            primaryColor: "#00E8D1",
            secondaryColor: "#5921DE",
            textColor1: "rgb(255, 255, 255)",
            textColor2: "grey",
            iconStyle: {
                background: "linear-gradient(to bottom, #4a00ff, cyan)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
            },
            backgroundColorDarker1: "rgb(3, 5, 41)",
            backgroundColor: "rgb(0 20 50)",
            backgroundColorLighter1: "rgb(28, 43, 85)",
            backgroundColorLighter2: "rgb(48, 63, 105)",
            backgroundColorLighter3: "rgb(108, 123, 165)",
            welcome_page_color_img_style: {
                // color it as blue-ish
                filter: "hue-rotate(210deg)",
            }
        }
    },
    "delphe": {
        name: "Delphe",
        url: "https://delphe.org",
        url_display: "delphe.org",
        file_format: ".delphe",
        theme: {
            primaryColor: "#ffc107",
            secondaryColor: colorDarkRed,
            textColor1: "rgb(255, 255, 255)",  // white
            textColor2: "grey",  // grey
            iconStyle: {
                color: colorChocolate,
            },
            backgroundColorDarker1: "rgb(25, 25, 30)",
            backgroundColor: "rgb(25, 30, 35)",
            backgroundColorLighter1: "rgb(45, 50, 55)",
            backgroundColorLighter2: "rgb(55, 60, 65)",
            backgroundColorLighter3: "rgb(105, 110, 115)",
        }
    }
}
export const appConfig = appConfigs.tokkenR


let IS_WEB_BUILD = process.env.IS_WEB_BUILD
console.log("IS_WEB_BUILD =", IS_WEB_BUILD)
IS_WEB_BUILD = IS_WEB_BUILD === 'true' || IS_WEB_BUILD === true
console.log("IS_WEB_BUILD =", IS_WEB_BUILD)

const Constants = {
    APP_NAME: packageJson.name,
    APP_VERSION: packageJson.version,

    URL: appConfig.url,
    URL_DISPLAY: appConfig.url_display,

    IS_WEB_BUILD: IS_WEB_BUILD,

    WINDOW_WIDTH_THRESHOLD_PX: 576,

    // select_wallet
    WALLET_TITLE: "Wallet " + appConfig.name,
    // WELCOME_TITLE: "Bienvenue sur l'application " + appConfig.name,
    // WELCOME_DESCRIPTION: "Issue, manage and swap digital tokens",
    // WELCOME_DESCRIPTION: "Votre portail vers le futur du web3",
    WELCOME_DESCRIPTION: "Digital Assets For The World",
    CREATE_NEW_WALLET: "Create new wallet",
    OPEN_REMEMBERED_WALLET: "Open saved wallet",
    OPEN_REMEMBERED_WALLET_INFO: "Unlock a wallet saved on this device",
    // CREATE_WALLET_HARDWARE: "Create a new wallet from hardware",
    // CREATE_WALLET_HARDWARE_INFO: "Connect your hardware wallet to create a new app wallet",
    RESTORE_FROM_FILE: "Load from file",
    RESTORE_WALLET_SEED: "Restore from secret backup phrase (seed)",
    CREATE_WALLET_INFO: "Choose this option if this is your first time using the app",
    RESTORE_FROM_FILE_INFO: "Import a " + appConfig.file_format + " file to load your wallet",
    RESTORE_SEED_INFO: "Enter your 13 words secret backup phrase (seed) to restore your wallet",

    MOCK_WALLET_PHRASE: "This example wallet cannot receive. Create a new wallet to receive.",

    // Google Forms waitlist — shown only on the mock/example wallet.
    WAITLIST_URL: "https://docs.google.com/forms/d/e/1FAIpQLScYWCSwLIDcoldHxszUI3BqEAno0FvvWb5TF2H2x5HQOOiJIQ/viewform",

    // restore_wallet_from_file
    INVALID_FILE: "The selected file is not valid",

    // create_new_wallet
    CREATE_WALLET_TITLE: "Create a new wallet on this device",
    ENTER_WALLET_NAME: "e.g. Savings, Trading",
    WALLET_INFO: "13-word secret seed phrase",
    SEED_INFO: "This secret phrase is extremely important — write it down on paper and keep it secret.",
    SEED_INFO_MORE: "It's everything you need to restore your wallet. If someone gets it, they can steal all your funds, and if you lose it, you will lose all your funds forever.",

    // create_new_wallet => create password
    PASSWORD_TITLE: "Secure your wallet with a password",
    PASSWORD_WARN: "This password cannot be recovered if you forget it. In that case, you will need to restore the wallet using the seed phrase you just wrote down.",
    PASSWORD_INFO: "Enter a password you will remember. It will be used to encrypt your wallet backup.",
    PASSWORD_FORM: "Password",
    PASSWORD_MSS: "your password must contain at least: ",
    LOWERCASE_RULE: "One lowercase letter",
    CAPITAL_RULE: "One uppercase letter",
    NUMBER_RULE: "One number",
    MIN_RULE: "At least 8 characters",
    RESTORE_WALLET_PAGE: "Restore a " + appConfig.name + " wallet",
    RESTORE_WALLET_TXT: "Restore from an encrypted backup file",
    MNEMONIC_SEED: "Restore from a secret seed phrase",
    MNEMONIC_SEED_PLACEHOLDER: "Enter the secret seed phrase",

    // wallet_unlock
    WALLET_UNLOCK_TITLE: "Unlock your wallet",
    WALLET_UNLOCK_INFO: "Enter the password to unlock this wallet.",
    WALLET_UNLOCK_WRONG_PASSWORD: "Wrong password. Please try again.",
    WALLET_UNLOCK_BACK: "Use a different wallet",

    // wallet_password download options
    DOWNLOAD_BACKUP_QUESTION: "Download an encrypted backup file?",
    DOWNLOAD_BACKUP_INFO: "We strongly recommend downloading an encrypted backup file and storing it safely. However, if you are on a device you do not fully trust, you can skip this step.",
    DOWNLOAD_BACKUP_YES: "Yes, download backup file",
    DOWNLOAD_BACKUP_NO: "No, skip download",
    REMEMBER_DEVICE_QUESTION: "Remember this wallet on this device",
    REMEMBER_DEVICE_INFO: "If checked, an encrypted copy of your wallet will be stored on this device so you don't need to re-enter your seed phrase next time. You will still need your password to unlock it.",

    // BackupChoiceModal
    BACKUP_CHOICE_TITLE: "Backup your wallet",
    BACKUP_CHOICE_DOWNLOAD: "Download encrypted backup",
    BACKUP_CHOICE_SKIP: "Continue without downloading",
    BACKUP_CHOICE_SKIP_CONFIRM: "You can still access your wallet with your 13-word recovery phrase, but you won't have a local backup file on this device.",
    BACKUP_CHOICE_DOWNLOADING: "Downloading...",
    BACKUP_CHOICE_DOWNLOADED: "Backup file downloaded successfully.",
    BACKUP_CHOICE_VERIFY_PROMPT: "Confirm you can decrypt it — re-enter your password:",
    BACKUP_CHOICE_VERIFY_SUCCESS: "Verified — your backup file is usable.",
    BACKUP_CHOICE_VERIFY_FAILED: "Password doesn't match the backup. You can re-download or continue.",
    BACKUP_CHOICE_VERIFY_SKIP: "skip this check",
    BACKUP_CHOICE_CONTINUE: "Continue to wallet",
    BACKUP_CHOICE_REDOWNLOAD: "Re-download",
    BACKUP_CHOICE_CONTINUE_ANYWAY: "Continue anyway",

    // errors
    ERROR_INTROMESSAGE: <>
        An error has occurred.<br /><br />
        You can try to continue. If the error persists, contact support with the additional information.
        <br /><br />
    </>,
    ERROR_NETWORK_INTROMESSAGE: <>
        Connection error — your device appears to be offline.<br /><br />
        Please check your Internet connection, then click <b>Retry</b> to reload your wallet.
        <br /><br />
    </>,

    // send tokens
    // SEND_TOKENS_POPOVER: "We maximize your privacy by "
    //     + "combining only the minimum necessary number of the smallest token sets for each transaction.",

    IMAGES: {
        delphe_logo: delphe_logo,
        delphe_logo_banner: delphe_logo_banner,
        delphe_logo_D: delphe_logo_D,
        bsv_logo: bsv_logo,
    },

}

export default Constants

